// extracted by mini-css-extract-plugin
export default {"section":"SectionUserGateway_section__LffF-"};